// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__dkogN","content":"LayoutSettings_content__3Ujaf"};